/* ===========================================================================
   LMP lightweight usage tracking.
   Captures how visitors move through the site so LMP can see which US stores
   they click out to and what they search for. Every event is:
     • pushed to window.dataLayer  (picked up by GA4 / GTM if installed)
     • sent to window.LMP_TRACK_ENDPOINT via navigator.sendBeacon (if set)
   Outbound store links also get UTM tags so the destination + LMP analytics
   can attribute the referral. No cookies, no PII; degrades to a no-op when no
   endpoint/dataLayer is present. Point LMP_TRACK_ENDPOINT at your collector
   (the LMP serverless API, a GA4 Measurement Protocol URL, etc.).
   =========================================================================== */
(function () {
  'use strict';

  var ENDPOINT = window.LMP_TRACK_ENDPOINT || '';
  var UTM = { utm_source: 'lmp-shipping', utm_medium: 'referral', utm_campaign: 'store-directory' };

  /* A stable per-visit id (session-scoped, anonymous) to stitch events. */
  var visit;
  try {
    visit = sessionStorage.getItem('lmp-visit');
    if (!visit) { visit = 'v' + Math.floor(performance.now()) + '-' + (history.length || 0); sessionStorage.setItem('lmp-visit', visit); }
  } catch (e) { visit = 'v0'; }

  function send(type, data) {
    var evt = { event: 'lmp_' + type, type: type, visit: visit, path: location.pathname, ref: document.referrer || '' };
    for (var k in data) { if (Object.prototype.hasOwnProperty.call(data, k)) evt[k] = data[k]; }
    (window.dataLayer = window.dataLayer || []).push(evt);
    if (ENDPOINT) {
      try {
        var body = JSON.stringify(evt);
        if (navigator.sendBeacon) navigator.sendBeacon(ENDPOINT, new Blob([body], { type: 'application/json' }));
        else fetch(ENDPOINT, { method: 'POST', body: body, headers: { 'Content-Type': 'application/json' }, keepalive: true }).catch(function () {});
      } catch (e) {}
    }
  }

  /* Add UTM params to an outbound store URL (leaves existing params intact). */
  function tagUrl(href) {
    try {
      var u = new URL(href, location.href);
      for (var k in UTM) { if (!u.searchParams.has(k)) u.searchParams.set(k, UTM[k]); }
      return u.toString();
    } catch (e) { return href; }
  }

  /* Page view. */
  send('page_view', { title: document.title });

  /* Outbound store clicks (marquee chips + grid tiles). Delegated so it also
     covers content injected after load. */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[data-lmp-store-link]');
    if (!a) return;
    var store = a.getAttribute('data-store') || a.textContent.trim();
    a.href = tagUrl(a.href); // ensure the actual navigation carries UTMs
    send('store_click', { store: store, href: a.href });
  }, true);

  /* Store search box usage (debounced; logs the query, not keystrokes). */
  var searchTimer;
  document.addEventListener('input', function (e) {
    var input = e.target;
    if (!input.matches || !input.matches('[data-lmp-search]')) return;
    clearTimeout(searchTimer);
    var q = input.value.trim();
    searchTimer = setTimeout(function () { if (q.length >= 2) send('store_search', { query: q }); }, 600);
  });
})();
